import { atom } from 'jotai';
export const promptAtom = atom<string>('');
